module.exports = __webpack_public_path__ + "assets/emoticon-3star.08357aa9.svg";